import React from 'react';

import WorkoutLogger from './WorkoutLogger';

interface AthleteWorkoutSectionProps {
  kiloClassId: string;
  athleteKiloClassId: string | undefined;
  hasStarted?: boolean;
  legacyNotes?: string | null;
}

const AthleteWorkoutSection = ({
  kiloClassId,
  athleteKiloClassId,
  hasStarted = false,
  legacyNotes,
}: AthleteWorkoutSectionProps): JSX.Element | null => {
  return (
    <WorkoutLogger
      kiloClassId={kiloClassId}
      athleteKiloClassId={athleteKiloClassId}
      hasStarted={hasStarted}
      legacyNotes={legacyNotes}
    />
  );
};

export default AthleteWorkoutSection;
